import axios from "axios";
import tokenService from "@/services/TokenService";

const SchoolAdminService = {
    /**
     * Get list of all Admin and Super Admin users (for MultiSelect dropdown)
     */
    getAdminList: async (router, store) => {
        const config = tokenService.getConfig(router, store);
        return await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/schools/admins/list', config)
            .then((response) => {
                return {
                    status: 'success',
                    admins: response.data.admins
                };
            }).catch((error) => {
                console.error('Failed to fetch admin list:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message || 'Failed to fetch admin list'
                };
            });
    },

    /**
     * Get assigned admins for a specific school
     */
    getSchoolAdmins: async (router, store, schoolId) => {
        const config = tokenService.getConfig(router, store);
        return await axios.get(process.env.VUE_APP_API_BASE_URL + `/api/schools/${schoolId}/admins`, config)
            .then((response) => {
                return {
                    status: 'success',
                    admins: response.data.admins
                };
            }).catch((error) => {
                console.error('Failed to fetch school admins:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message || 'Failed to fetch school admins'
                };
            });
    },

    /**
     * Update assigned admins for a specific school (Super Admin only)
     */
    updateSchoolAdmins: async (router, store, schoolId, adminIds) => {
        const config = tokenService.getConfig(router, store);
        return await axios.put(
            process.env.VUE_APP_API_BASE_URL + `/api/schools/${schoolId}/admins`,
            { admin_ids: adminIds },
            config
        )
            .then((response) => {
                return {
                    status: 'success',
                    message: response.data.message,
                    assigned_count: response.data.assigned_count
                };
            }).catch((error) => {
                console.error('Failed to update school admins:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message || 'Failed to update school admins'
                };
            });
    },
};

export default SchoolAdminService;
